// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setting-wrapper-box {
  /* padding-left: 10px; */
  display: flex;
  width: 280px;
  background-color: #F5F5F5;
  border-radius: 8px;
  padding: 0.75rem;
  flex-direction: column;
  gap: 0.5rem;
  overflow-y: auto;
}

.dark .setting-wrapper-box {
  background-color: #5E5F69;
}

.main-grid-wrapper-box {
  width: 100%;
  padding: 5px;
}

.setting-wrapper-outer-par {
  width: 100%;
  background-color: #fff;
  border-radius: 10px;
  padding: 0.75rem;
  display: flex;
  gap: 1rem;
  height: 82vh;
}

.dark .setting-wrapper-outer-par {
  background-color: #363743;
}

.grid-wapper-box {
  /* height: 100px; */
  border-radius: 5px;
  cursor: pointer;
  /* box-shadow: 0 1.5rem 4rem rgba(#000, 0.5); */
  border: 1px solid #F5F5F5;
  /* gap: 15px; */
  color: #333;
  background-color: #F5F5F5;
}
.dark .grid-wapper-box {
  background-color: #5E5F69;
  border: 1px solid #5E5F69;
  color: #fff;
}

.dark .icon-1 {
  color: #fff;
}

.light .grid-wapper-box {
  background-color: white;
}

/* .grid-wapper-box:hover {
  background-color: #0860E6 !important;
  color: #fff;
} */

.grid-wrapper-icon-box {
  display: flex;
  align-items: center;
  margin-left: 5px;
  font-size: 1.5em !important;
}

.inner-grid-wrapper-box {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 8px;
  font-size: 0.85rem;
}

.settins-tab-icon-par {
  height: 1.25rem;
}

.settins-tab-icon-par svg {
  height: 100%;
}

.inner-text-grid-wrapper-box {
  padding: 5px;
}

.inner-text-content {
  /* margin-left: 50px; */
  font-size: 0.8em !important;
  font-weight: 600;
}

.dark .brightness-wrapper-box-select {
  color: #fff !important;
}

.setting-brightness-wrapper-box {
  height: 100%;
  padding: 5px;
  margin-top: 5px;
}

.brightness-wrapper-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  top: 90%;
  transform: translateY(600px);
}

.setting-container {
  width: 100% !important;
  margin-top: 1.2rem;
  padding: 1rem;
  padding-top: 0;
}

.setting-header-row-par {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 50px 0 1rem 0;
  background-color: #fff;
  border-radius: 10px;
  padding: 0.8rem;
  color: var(--surface-g5);
}

.dark .setting-header-row-par {
  background-color: var(--dark-blue);
  color: #fff;
}

.dark .setting-container {
  background-color: #2b2f42;
}
.dark .inner-text-content {
  color: #fff;
}

.dark .dark-white-text {
  color: #fff;
}

.active-module-settings {
  background-color: #0860E6 !important;
  border: 1px solid #0860E6;
  border-radius: 5px;
  /* transition:
    background-color 0.3s ease,
    opacity 0.3s ease,
    border-color 0.3s ease; */
    color: #fff;
}

.active-module-settings svg {
  color: #fff;
  height: 100%;
}

/* New Changes */
.settings-title {
  /* padding: 0px 20px; */
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 100%;
  letter-spacing: 0%;
}

/*............Till Here............*/

.setting-main-output-screen {
  width: 100%;
  margin-top: 2px;
  height: 100%;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/settings.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,+CAA+C;EAC/C,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB;;;6BAG2B;IACzB,WAAW;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,oCAAoC;;AAEpC;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".setting-wrapper-box {\n  /* padding-left: 10px; */\n  display: flex;\n  width: 280px;\n  background-color: #F5F5F5;\n  border-radius: 8px;\n  padding: 0.75rem;\n  flex-direction: column;\n  gap: 0.5rem;\n  overflow-y: auto;\n}\n\n.dark .setting-wrapper-box {\n  background-color: #5E5F69;\n}\n\n.main-grid-wrapper-box {\n  width: 100%;\n  padding: 5px;\n}\n\n.setting-wrapper-outer-par {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 10px;\n  padding: 0.75rem;\n  display: flex;\n  gap: 1rem;\n  height: 82vh;\n}\n\n.dark .setting-wrapper-outer-par {\n  background-color: #363743;\n}\n\n.grid-wapper-box {\n  /* height: 100px; */\n  border-radius: 5px;\n  cursor: pointer;\n  /* box-shadow: 0 1.5rem 4rem rgba(#000, 0.5); */\n  border: 1px solid #F5F5F5;\n  /* gap: 15px; */\n  color: #333;\n  background-color: #F5F5F5;\n}\n.dark .grid-wapper-box {\n  background-color: #5E5F69;\n  border: 1px solid #5E5F69;\n  color: #fff;\n}\n\n.dark .icon-1 {\n  color: #fff;\n}\n\n.light .grid-wapper-box {\n  background-color: white;\n}\n\n/* .grid-wapper-box:hover {\n  background-color: #0860E6 !important;\n  color: #fff;\n} */\n\n.grid-wrapper-icon-box {\n  display: flex;\n  align-items: center;\n  margin-left: 5px;\n  font-size: 1.5em !important;\n}\n\n.inner-grid-wrapper-box {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 8px;\n  font-size: 0.85rem;\n}\n\n.settins-tab-icon-par {\n  height: 1.25rem;\n}\n\n.settins-tab-icon-par svg {\n  height: 100%;\n}\n\n.inner-text-grid-wrapper-box {\n  padding: 5px;\n}\n\n.inner-text-content {\n  /* margin-left: 50px; */\n  font-size: 0.8em !important;\n  font-weight: 600;\n}\n\n.dark .brightness-wrapper-box-select {\n  color: #fff !important;\n}\n\n.setting-brightness-wrapper-box {\n  height: 100%;\n  padding: 5px;\n  margin-top: 5px;\n}\n\n.brightness-wrapper-box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 12px;\n  top: 90%;\n  transform: translateY(600px);\n}\n\n.setting-container {\n  width: 100% !important;\n  margin-top: 1.2rem;\n  padding: 1rem;\n  padding-top: 0;\n}\n\n.setting-header-row-par {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin: 50px 0 1rem 0;\n  background-color: #fff;\n  border-radius: 10px;\n  padding: 0.8rem;\n  color: var(--surface-g5);\n}\n\n.dark .setting-header-row-par {\n  background-color: var(--dark-blue);\n  color: #fff;\n}\n\n.dark .setting-container {\n  background-color: #2b2f42;\n}\n.dark .inner-text-content {\n  color: #fff;\n}\n\n.dark .dark-white-text {\n  color: #fff;\n}\n\n.active-module-settings {\n  background-color: #0860E6 !important;\n  border: 1px solid #0860E6;\n  border-radius: 5px;\n  /* transition:\n    background-color 0.3s ease,\n    opacity 0.3s ease,\n    border-color 0.3s ease; */\n    color: #fff;\n}\n\n.active-module-settings svg {\n  color: #fff;\n  height: 100%;\n}\n\n/* New Changes */\n.settings-title {\n  /* padding: 0px 20px; */\n  font-weight: 700;\n  font-size: 1.5rem;\n  line-height: 100%;\n  letter-spacing: 0%;\n}\n\n/*............Till Here............*/\n\n.setting-main-output-screen {\n  width: 100%;\n  margin-top: 2px;\n  height: 100%;\n  overflow-y: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
